import { createContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import axios from "axios";

export const LoginUserContext = createContext({});

export const LoginUserProvider = (props) => {
  const { children } = props;
  const [isLogined, setIsLogined] = useState(false);
  const [loginUser, setLoginUser] = useState("");
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(Cookies.get("token"));

  useEffect(() => {
    if (token) {
      setIsLogined(true);
      axios.defaults.headers.common["Authorization"] = `Token ${token}`;

      setLoading(false);
    }
    console.log("tokenが更新されました token:", token);
  }, [token]);

  return (
    <LoginUserContext.Provider
      value={{
        isLogined,
        setIsLogined,
        loginUser,
        setLoginUser,
        loading,
        setLoading,
        token,
        setToken,
      }}
    >
      {children}
    </LoginUserContext.Provider>
  );
};
